import { render, staticRenderFns } from "./DefaultOtpModal.vue?vue&type=template&id=498576e4&scoped=true&"
import script from "./DefaultOtpModal.vue?vue&type=script&lang=js&"
export * from "./DefaultOtpModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultOtpModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DefaultOtpModal.vue?vue&type=style&index=1&id=498576e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498576e4",
  null
  
)

export default component.exports